<template>
  <div
    v-if="visible"
    class="app-route-loader"
    role="status"
    aria-live="polite"
    aria-label="Chargement de la page"
  >
    <div class="app-route-loader__bar" aria-hidden="true"></div>
    <div class="app-route-loader__badge">
      <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
      <span>Chargement...</span>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

const ROUTE_LOADER_DELAY_MS = 200;

export default defineComponent({
  name: 'AppRouteLoader',
  data() {
    return {
      showTimer: null as number | null,
      visible: false,
    };
  },
  computed: {
    isRouteLoading(): boolean {
      return Boolean(this.$store.getters['navigation/isRouteLoading']);
    },
  },
  watch: {
    isRouteLoading: {
      immediate: true,
      handler(loading: boolean): void {
        if (loading) {
          this.scheduleLoader();
          return;
        }

        this.hideLoader();
      },
    },
  },
  beforeUnmount(): void {
    this.clearShowTimer();
  },
  methods: {
    scheduleLoader(): void {
      if (this.visible || this.showTimer !== null) {
        return;
      }

      this.showTimer = window.setTimeout(() => {
        this.showTimer = null;
        this.visible = true;
      }, ROUTE_LOADER_DELAY_MS);
    },

    hideLoader(): void {
      this.clearShowTimer();
      this.visible = false;
    },

    clearShowTimer(): void {
      if (this.showTimer === null) {
        return;
      }

      window.clearTimeout(this.showTimer);
      this.showTimer = null;
    },
  },
});
</script>

<style scoped>
.app-route-loader {
  inset: 0 0 auto;
  pointer-events: none;
  position: fixed;
  z-index: 1100;
}

.app-route-loader__bar {
  animation: app-route-loader-slide 1.05s ease-in-out infinite;
  background: linear-gradient(90deg, #0d6efd 0%, #20c997 55%, #ffc107 100%);
  box-shadow: 0 0 10px rgba(13, 110, 253, 0.28);
  height: 3px;
  transform-origin: left center;
  width: 100%;
}

.app-route-loader__badge {
  align-items: center;
  background: rgba(255, 255, 255, 0.96);
  border: 1px solid rgba(33, 37, 41, 0.08);
  border-radius: 999px;
  box-shadow: 0 0.75rem 1.5rem rgba(15, 23, 42, 0.14);
  color: #212529;
  display: inline-flex;
  font-size: 0.875rem;
  font-weight: 600;
  gap: 0.5rem;
  line-height: 1;
  padding: 0.625rem 0.875rem;
  position: fixed;
  right: 1rem;
  top: 0.875rem;
}

.app-route-loader__badge .fa-spinner {
  color: #0d6efd;
}

@keyframes app-route-loader-slide {
  0% {
    transform: scaleX(0.18);
  }

  45% {
    transform: scaleX(0.72);
  }

  100% {
    transform: scaleX(1);
  }
}

@media (max-width: 575.98px) {
  .app-route-loader__badge {
    left: 50%;
    right: auto;
    top: 0.75rem;
    transform: translateX(-50%);
  }
}
</style>
